export default __webpack_public_path__ + "static/media/Prachi.517b6e85.png";